import {Companies, Matches, Properties, RandomEvents} from "./models.js";

function GimmickMatch() {

    // Float
    const ratingBoost = null;
    const popularityIncrease = null;
    const popularityDecrease = null;
    const injuryRate = null;

    // Integer
    const cost = null;
    const level = 1;
    const xp = 0;
    const monthsToExpire = 12;

    // Strings
    const name = null;
    const description = null;
    const cashinContractName = null;
    const consequence = null;
    const rules = null;
    const graphicType = null;
    const matchContractName = null;

    // Boolean
    const available = true;
    const generateObject = false;
    const generateLocation = false;
    const standard = false;
    const special = false;
    const addRandomWeapons = false;

    // Foreign keys
    const companyId = null;
    const propertyId = null;

    return {
        ratingBoost,
        popularityIncrease,
        popularityDecrease,
        injuryRate,
        cost,
        level,
        xp,
        monthsToExpire,
        name,
        description,
        cashinContractName,
        consequence,
        rules,
        graphicType,
        matchContractName,
        available,
        generateObject,
        generateLocation,
        standard,
        special,
        addRandomWeapons,
        companyId,
        propertyId,
    };
}

function addGimmickMatchMatches(gimmickMatch, matches) {
    matches.forEach(c => {
        c.gimmickMatchId = gimmickMatch.$loki
    });
}

function removeGimmickMatchMatches(gimmickMatch, matches) {
    matches.forEach(c => {
        c.gimmickMatchId = null
    });
}

function getGimmickMatchMatches(gimmickMatch) {
    return Matches.find({'gimmickMatchId': gimmickMatch.$loki});
}

function getGimmickMatchCompany(gimmickMatch) {
    return Companies.find({'$loki': gimmickMatch.companyId})[0];
}

function getGimmickMatchProperty(gimmickMatch) {
    return Properties.find({'$loki': gimmickMatch.propertyId})[0];
}

function addGimmickMatchRandomEvents(gimmickMatch, randomEvents) {
    randomEvents.forEach(c => {
        c.gimmickMatchId = gimmickMatch.$loki
    });
}

function removeGimmickMatchRandomEvents(gimmickMatch, randomEvents) {
    randomEvents.forEach(c => {
        c.gimmickMatchId = null
    });
}

function getGimmickMatchRandomEvents(gimmickMatch) {
    return RandomEvents.find({'gimmickMatchId': gimmickMatch.$loki});
}

export { GimmickMatch, addGimmickMatchMatches, removeGimmickMatchMatches, getGimmickMatchMatches,
    getGimmickMatchCompany, getGimmickMatchProperty, addGimmickMatchRandomEvents, removeGimmickMatchRandomEvents,
    getGimmickMatchRandomEvents }
